import { EventDataTypeEnum } from "../../../store/types/work.types";

export const FILE_EVENT_TYPES: EventDataTypeEnum[] = [
  EventDataTypeEnum.FileCrmDocument,
  EventDataTypeEnum.FileConfirmationSent,
  EventDataTypeEnum.FileInvoiceSent,
  EventDataTypeEnum.FileCombinedClaim,
  EventDataTypeEnum.ContractFile,
  EventDataTypeEnum.ContractFiles,
  EventDataTypeEnum.CustomerDocument,
  EventDataTypeEnum.CustomerPoaDocument,
  EventDataTypeEnum.BankIDSignedFile,
  EventDataTypeEnum.SendMailPdf,
  EventDataTypeEnum.ExternalSaleFiles,
  EventDataTypeEnum.SecureVolumeContractFile,
  EventDataTypeEnum.SecureVolumeSignedContractFile,
];
